import { Injectable } from '@angular/core';
import { Geoposition } from '@awesome-cordova-plugins/geolocation/ngx';
import { Platform } from '@ionic/angular';
import { Guid } from '@models/guid';
import { Observable, of } from 'rxjs';
import { ILocationProvider } from '../../schema/interfaces/location-provider';
import { BackgroundLocationService } from './background-location/background-location.service';
import { ForegroundLocationService } from './foreground-location/foreground-location.service';

@Injectable()
export class LocationProviderService {
  get $location(): Observable<Geoposition> {
    return this.provider.$change;
  }

  private _provider: ILocationProvider = null;
  private get provider(): ILocationProvider {
    if (this._provider === null) {
      this._provider = this.platform.is('cordova') ? this.backgroundLocation : this.foregroundLocation;
    }
    return this._provider;
  }

  private _started: boolean = false;

  constructor(
    private platform: Platform,
    private backgroundLocation: BackgroundLocationService,
    private foregroundLocation: ForegroundLocationService
  ) {}

  getCurrent(): Promise<Geoposition> {
    return this.provider.getCurrent();
  }

  start(uid: Guid): Observable<void> {
    return this._started === true ? of(null) : this.startProvider(uid);
  }

  /**
   * @param uid id of my current resource in Saga's system
   */
  private startProvider(uid: Guid): Observable<void> {
    this._started = true;
    this.provider.setup(uid);
    return this.provider.start();
  }

  stop(): Promise<void> {
    return this._started === false
      ? Promise.resolve()
      : this.provider.stop().then(() => {
          this._started = false;
        });
  }
}
